import React, { Component } from 'react';
import I18n from 'i18n-js';
import { func, bool, array, string, number } from 'prop-types';
import { Modal, Row, Col, Button, Input } from 'grab-ui';
import classnames from 'classnames';
import _get from 'lodash/get';
import {
  CANCEL_REASON_I18N_MAP,
  DEFAULT_RATING,
  ID_OTHER_REASON,
} from 'constants/app-constants';
import css from './feedback-modal.less';

const TextArea = Input.TextArea;

export default class FeedbackModal extends Component {
  static propTypes = {
    visible: bool,
    closeable: bool,
    handleSubmit: func.isRequired,
    cancelReasons: array.isRequired, //eslint-disable-line
    deliveryID: string,
    expressServiceID: number,
    isMSDBooking: bool,
    onCancel: func,
  };

  static defaultProps = {
    visible: false,
    deliveryID: '',
    isMSDBooking: false,
    closeable: false,
    expressServiceID: 0,
    onCancel: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      clickedFeedback: {
        id: '',
        content: '',
      },
      comment: '',
    };
  }

  onTypingComment = ({ target: { value: comment } }) => {
    this.setState({ comment });
  };

  handleSelectOptions = (feedbackId, response) => () => {
    this.setState({
      clickedFeedback: {
        id: feedbackId,
        content: response,
      },
    });
  };

  collectFormValues = () => {
    const { clickedFeedback, comment } = this.state;
    const { deliveryID, isMSDBooking, expressServiceID } = this.props;

    const mcqReason =
      comment.length !== 0 && clickedFeedback.id !== ID_OTHER_REASON
        ? [clickedFeedback.id, ID_OTHER_REASON]
        : [clickedFeedback.id];
    const payloadComment =
      comment.length === 0 ? clickedFeedback.content : comment;

    this.setState({
      clickedFeedback: {
        id: '',
        content: '',
      },
      comment: '',
    });

    return {
      req: {
        deliveryID,
        expressServiceID,
        feedback: {
          comment: payloadComment,
          mcqReason,
          rating: DEFAULT_RATING,
        },
        isMSDBooking,
      },
    };
  };

  handleSubmitFeedBack = () => {
    const { handleSubmit } = this.props;
    const formValues = this.collectFormValues();
    handleSubmit(formValues);
  };

  handleCancelFeedback = () => {
    const { onCancel } = this.props;
    const formValues = this.collectFormValues();
    onCancel(formValues);
  };

  render() {
    const { visible, cancelReasons, closeable } = this.props;
    const { clickedFeedback } = this.state;
    return (
      <div>
        <Modal
          centered
          // make submit feedback compulsory
          closable={closeable}
          visible={visible}
          onCancel={this.handleCancelFeedback}
          style={{ top: 100 }}
          className={css.feedbackModal}
          footer={[
            <Button
              disabled={!clickedFeedback.id}
              type="primary"
              key="submit"
              onClick={this.handleSubmitFeedBack}
            >
              {I18n.t('v2.commonButton.submit')}
            </Button>,
          ]}
        >
          <Row>
            <p className={css.heading}>
              {I18n.t('history.feedbackItems.title')}
            </p>
          </Row>
          <div className={css.wrappedContainer}>
            {cancelReasons.length > 0
              ? cancelReasons.map(cancelReason => (
                  <Row
                    onClick={this.handleSelectOptions(
                      cancelReason.id,
                      cancelReason.response,
                    )}
                    className={classnames(css.container, {
                      [`${css.hightlightOption}`]:
                        cancelReason.id === this.state.clickedFeedback.id,
                    })}
                    key={cancelReason.id}
                    type="flex"
                  >
                    <Col className={css.wrappedIcon} span={2}>
                      <img
                        className={css.tralvelOptionIcon}
                        src={cancelReason.icon}
                        alt="Grab"
                      />
                    </Col>
                    <Col offset={1} span={21}>
                      <p>
                        {cancelReason.response ||
                          I18n.t(
                            _get(
                              CANCEL_REASON_I18N_MAP,
                              cancelReason.id,
                              'history.feedbackItems.empty',
                            ),
                          )}
                      </p>
                    </Col>
                  </Row>
                ))
              : null}
            <Row>
              <Col className={css.container} span={20}>
                <TextArea
                  placeholder={I18n.t('history.feedbackItems.shareThought')}
                  onChange={this.onTypingComment}
                />
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    );
  }
}
